import { useEffect, useState } from 'react';
import { FaTimes } from 'react-icons/fa';
import { useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import { toast } from 'react-hot-toast';
import { updateDataWhenCreate, updateDataWhenUpdate } from '../../../../services/helpers';
import { usersApi } from '../../api/users.api';
import { invitationSchema } from '../../schemas/invitations.schema';
import { MODE } from '../../../../interaces/mode.interface';
import { useRoles } from '../../../roles/hooks/useRoles';
import { Controller } from 'react-hook-form';
import Select from 'react-select';
import { TOAST_SUCCESS_IDS, TOAST_ERROR_IDS } from '../../../../interaces/toast.ids.interface';
import styles from '../../styles/styles.module.css';
function ModalInvitations({ onClose, model = null, mode = MODE.CREATE, setEntities }) {
  const [requiresForce, setRequiresForce] = useState(false);
  const { getNames, names: roles } = useRoles();
  useEffect(() => {
    getNames();
  }, []);

  const {
    register,
    handleSubmit,
    reset,
    setValue,
    control,
    formState: { errors, isSubmitting },
  } = useForm({
    resolver: zodResolver(invitationSchema),
    defaultValues: {
      email: '',
      roleToGrant: 'DIRECTOR',
      force: false,
    },
  });

  useEffect(() => {
    if (model && mode === MODE.UPDATE) {
      reset({
        email: model.email,
        roleToGrant: model.roleToGrant,
        force: false,
      });

      setRequiresForce(false);
    }
  }, [model, mode, reset]);

  const onSubmit = async (data) => {
    try {
      if (mode == MODE.CREATE) {
        const response = await usersApi.createInvitation(data);
        updateDataWhenCreate(setEntities, response);
      } else {
        const response = await usersApi.updateInvitation(model.id, data);
        updateDataWhenUpdate(setEntities, response);
      }

      toast.success(
        mode === MODE.CREATE
          ? TOAST_SUCCESS_IDS.RECORD_SAVED_SUCCESSFULLY
          : TOAST_SUCCESS_IDS.RECORD_UPDATED_SUCCESSFULLY,
        { id: TOAST_SUCCESS_IDS.RECORD_SAVED_SUCCESSFULLY }
      );
      onClose();
    } catch (error) {
      if (error.status === 409) {
        setRequiresForce(true);
        toast.error('Ya existe una invitación pendiente para este usuario.');
        return;
      }
      toast.error(
        (error.message && error.message !== 'Error'
          ? error.message
          : TOAST_ERROR_IDS.ERROR_PERFORMING_THIS_ACTION) ||
          TOAST_ERROR_IDS.ERROR_PERFORMING_THIS_ACTION,
        { id: TOAST_ERROR_IDS.TWO }
      );
    }
  };

  const handleResend = () => {
    setValue('force', true);
    setRequiresForce(false);

    // Obtenemos nuevamente los datos del formulario
    handleSubmit(onSubmit)();
  };

  return (
    <div className="modal-overlay">
      <div className="modal-content modal-sizes">
        {/* Header */}
        <div className="modal-header">
          <h2 className="modal-title">Enviar Invitación</h2>
          <button type="button" onClick={onClose} className="modal-close-btn">
            <FaTimes />
          </button>
        </div>

        {/* Body */}
        <div className="modal-body">
          <p className="modal-description">
            Captura el correo electrónico y el rol que deseas otorgar al usuario.
          </p>

          <form onSubmit={handleSubmit(onSubmit)} className="modal-form">
            <div className="modal-div-columns">
              {/* Correo */}
              <div className="modal-div-column">
                <label className="label-base">
                  Correo Electrónico
                  <p className="modal-input-required">*</p>
                </label>

                <input
                  type="email"
                  placeholder="correo@dominio.com"
                  className="input-base"
                  {...register('email')}
                />

                {errors.email && <span className="error-text">{errors.email.message}</span>}
              </div>

              {/* Rol */}
              <div className="modal-div-column">
                <label className="label-base">
                  Rol a otorgar <p className="modal-input-required">*</p>
                </label>
                <Controller
                  name="roleToGrant"
                  control={control}
                  render={({ field }) => (
                    <Select
                      options={roles}
                      getOptionLabel={(option) => option.name}
                      getOptionValue={(option) => option.name}
                      value={roles.find((option) => option.name === field.value) || null}
                      onChange={(option) => field.onChange(option.name)}
                      isSearchable={false}
                      placeholder="Selecciona un rol"
                    />
                  )}
                />
                {errors.role && <span className="error-text">{errors.role.message}</span>}
              </div>
            </div>

            {/* Mensaje de invitación existente */}
            {requiresForce && (
              <div className={`${styles.divRequiresForce}`}>
                <p className={`${styles.divRequiresForceNote}`}>
                  Ya existe una invitación pendiente para este usuario.
                </p>

                <p className={`${styles.divRequiresForceNote2}`}>
                  Puedes enviarla nuevamente si deseas reemplazar o reenviar la invitación.
                </p>
              </div>
            )}

            {/* Footer */}
            <div className="modal-footer">
              <button
                type="button"
                onClick={onClose}
                className="btn-cancel"
                disabled={isSubmitting}
              >
                Cancelar
              </button>

              {requiresForce ? (
                <button
                  type="button"
                  onClick={handleResend}
                  disabled={isSubmitting}
                  className={`btn-primary ${styles.btnForward}`}
                >
                  {isSubmitting ? 'Reenviando...' : 'Enviar Nuevamente'}
                </button>
              ) : (
                <button type="submit" disabled={isSubmitting} className="btn-primary">
                  {isSubmitting
                    ? 'Guardando...'
                    : mode === MODE.CREATE
                      ? 'Enviar invitación'
                      : 'Actualizar invitación'}
                </button>
              )}
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default ModalInvitations;
